var map = {
	"./PM_2.2.2.png": 45516,
	"./PM_2.3.2.png": 81247,
	"./PM_3.2.2.png": 58300,
	"components/Catalog/PM/img/glass/pr/prPlusGrafit/PM_2.2.2.png": 45516,
	"components/Catalog/PM/img/glass/pr/prPlusGrafit/PM_2.3.2.png": 81247,
	"components/Catalog/PM/img/glass/pr/prPlusGrafit/PM_3.2.2.png": 58300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48511;